import { AppI18nConfig } from './types';

type AppSiteConfig = {
	appI18nConfig?: AppI18nConfig;
};

type AppConfig = {
	appI18nConfig?: AppI18nConfig;
	site?: Record<string, AppSiteConfig>;
};

export async function getAppI18nConfig(
	appName: string
): Promise<AppI18nConfig> {
	try {
		const config = require(`apps/${appName}/app.config.js`) as AppConfig;

		// Backward compatibility for apps still using top-level appI18nConfig.
		if (config.appI18nConfig) {
			return config.appI18nConfig;
		}

		const theme =
			process.env.THEME ||
			process.env.NEXT_PUBLIC_SITE ||
			process.env.NEXT_PUBLIC_CHANNEL ||
			'mancity';

		const themedConfig = config.site?.[theme]?.appI18nConfig;
		if (themedConfig) {
			return themedConfig;
		}

		const firstAvailableTheme = Object.keys(config.site ?? {})[0];
		const fallbackConfig = firstAvailableTheme
			? config.site?.[firstAvailableTheme]?.appI18nConfig
			: undefined;

		if (fallbackConfig) {
			console.warn(
				`[i18n] Theme "${theme}" not found for app "${appName}". Falling back to "${firstAvailableTheme}".`
			);
			return fallbackConfig;
		}

		throw new Error(`[i18n] appI18nConfig not found for app "${appName}".`);
	} catch (err) {
		console.warn(
			`[i18n] No config found for app "${appName}". Falling back to default.`
		);
		console.warn(err);
		return {
			defaultLocale: 'en',
			supportedLocales: ['en'],
		};
	}
}
